"use client"

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { TabsContent } from "@radix-ui/react-tabs"

type Props = {
  showTrade: boolean
  support: React.ReactNode
  trade: React.ReactNode
}

export default function SupportTabs({ support, trade, showTrade }: Props) {
  if (!showTrade) return <>{support}</>

  return (
    <Tabs defaultValue="support" className="w-full sm:mt-6 mt-4">
      <TabsList className="sm:w-full">
        <TabsTrigger value="support" className="sm:w-1/2">
          Support
        </TabsTrigger>
        <TabsTrigger value="trade" className="sm:w-1/2">
          Trade
        </TabsTrigger>
      </TabsList>

      <TabsContent value="support">{support}</TabsContent>
      <TabsContent value="trade">{trade}</TabsContent>
    </Tabs>
  )
}
